import { GridPaginationModel } from '@mui/x-data-grid-pro';
import { PrimitiveAtom, SetStateAction, useAtom, WritableAtom } from 'jotai';
import { useCallback } from 'react';

type useInventoryTablePaginationProps = {
  rowsPerPageFilterAtom: WritableAtom<number, [newValue: SetStateAction<number>], void>;
  pageFilterAtom: PrimitiveAtom<number>;
};

export const useInventoryTablePagination = ({
  rowsPerPageFilterAtom,
  pageFilterAtom,
}: useInventoryTablePaginationProps) => {
  const [rowsPerPage, setRowsPerPage] = useAtom(rowsPerPageFilterAtom);
  const [page, setPage] = useAtom(pageFilterAtom);

  const onPaginationChange = useCallback(
    (pagination: GridPaginationModel) => {
      if (pagination.page !== page) {
        setPage(pagination.page);
      }

      if (pagination.pageSize !== rowsPerPage) {
        setRowsPerPage(pagination.pageSize);
      }
    },
    [page, rowsPerPage, setPage, setRowsPerPage],
  );

  return {
    page,
    rowsPerPage,
    onPaginationChange,
  };
};
